export default {
  timings: [
    {
      portfolio_url: 'MotionClub',
      start: 1,
      end: 6
    },
    {
      portfolio_url: 'Lorica',
      start: 7,
      end: 13
    },
    {
      portfolio_url: 'MauriceBaltissen',
      start: 14,
      end: 19
    },
    {
      portfolio_url: 'PeterNizic',
      start: 20,
      end: 31
    },
    {
      portfolio_url: 'GaryMayes',
      start: 32,
      end: 40
    },
    {
      portfolio_url: 'Tapocketa',
      start: 41,
      end: 48
    },
    {
      portfolio_url: 'Gordei',
      start: 49,
      end: 57
    },
    {
      portfolio_url: 'MarvinTe',
      start: 58,
      end: 66
    },
    {
      portfolio_url: 'MotionClub',
      start: 67,
      end: 72
    },
    {
      portfolio_url: 'Cube',
      start: 73,
      end: 77
    },
    {
      portfolio_url: 'StephenTurcotte',
      start: 78,
      end: 81
    },
    {
      portfolio_url: 'Echopic',
      start: 82,
      end: 89
    },
    {
      portfolio_url: 'Lorica',
      start: 90,
      end: 100
    },

  ]
}